import { forwardRef } from 'react'

const Input = forwardRef(function Input(
  {
    label,
    error,
    className = '',
    type = 'text',
    ...props
  },
  ref
) {
  const id = props.id || props.name

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={id}
        type={type}
        className={`form-input ${error ? 'has-error' : ''}`}
        {...props}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  )
})

export default Input
